import { render, staticRenderFns } from "./ToggleViews.vue?vue&type=template&id=07b44a72"
import script from "./ToggleViews.vue?vue&type=script&lang=js"
export * from "./ToggleViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports